import { createApp } from 'vue';
import { createI18n } from 'vue-i18n';
import VueDisableInterpolation from 'vue-disable-interpolation';
// eslint-disable-next-line import/extensions
import { ElLoading as Loading } from 'element-plus';
import Locales from '../vue-i18n-locales.generated';

export const initApp = () => {
  const i18n = createI18n({
    locale:
      document.querySelector('meta[name=trans-locale]').content
      || window.navigator.language
      || 'en',
    fallbackLocale:
      document.querySelector('meta[name=trans-fallback]').content || 'en',
    messages: Locales,
  });

  const app = createApp();
  app.use(i18n);
  app.use(VueDisableInterpolation);
  app.use(Loading.directive);
  return app;
};

export const mountApp = (app) => {
  window.app = app;
  const vm = app.mount('#common_layout');
  window.vm = vm;
};
